import {
  BaseRepository,
  parseError,
  sharedApiUrls,
} from "@features/shared/data";
import { AnnouncementsRepositoryContract } from "@features/shared/domain";
import {
  AnnouncementDetails,
  AnnouncementType,
} from "@features/shared/domain/types";

export class AnnouncementsRepository
  extends BaseRepository
  implements AnnouncementsRepositoryContract
{
  public async list(type: AnnouncementType): Promise<AnnouncementDetails[]> {
    try {
      const { data } = await this.http.get<{ data: AnnouncementDetails[] }>(
        sharedApiUrls.getAnnouncements,
        { params: { type } },
      );

      return data.data;
    } catch (error) {
      throw parseError(error);
    }
  }
}
